import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import type { OfficeComparisonRow } from "../lib/api/types";

export function OfficeComparisonChart({ rows }: { rows: OfficeComparisonRow[] }) {
  const data = rows.map((row) => ({
    office: row.officeName,
    pre: row.firstDecisionTimePreHours,
    // undefined (not null) so Recharts omits the bar entirely for non-live offices
    current: row.firstDecisionTimeCurrentHours ?? undefined,
  }));

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-center gap-4 text-xs text-muted-foreground">
        <span className="inline-flex items-center gap-2">
          <span
            className="size-3 rounded-sm"
            style={{ backgroundColor: "var(--neutral-inactive)" }}
          />
          Pre-Athena baseline
        </span>
        <span className="inline-flex items-center gap-2">
          <span className="size-3 rounded-sm" style={{ backgroundColor: "var(--amber)" }} />
          Current (live on Athena)
        </span>
      </div>

      <div className="h-[280px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 8, right: 8, bottom: 8, left: 0 }}>
            <CartesianGrid stroke="hsl(var(--border))" vertical={false} />
            <XAxis
              dataKey="office"
              tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 12 }}
              stroke="hsl(var(--border))"
            />
            <YAxis
              tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 12 }}
              stroke="hsl(var(--border))"
              label={{
                value: "First decision time (hrs)",
                angle: -90,
                position: "insideLeft",
                fill: "hsl(var(--muted-foreground))",
                fontSize: 11,
              }}
            />
            <Tooltip
              contentStyle={{
                background: "hsl(var(--popover))",
                border: "1px solid hsl(var(--border))",
                borderRadius: "0px",
                color: "hsl(var(--popover-foreground))",
                fontSize: 12,
              }}
              formatter={(value: number, name) => [
                `${value} hrs`,
                name === "pre" ? "Pre-Athena baseline" : "Current (live on Athena)",
              ]}
            />
            <Bar dataKey="pre" fill="var(--neutral-inactive)" radius={[3, 3, 0, 0]} maxBarSize={38} />
            <Bar dataKey="current" fill="var(--amber)" radius={[3, 3, 0, 0]} maxBarSize={38} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
